const baseStyle = {
  textDecoration: 'underline',
};

export default {
  baseStyle,
};
